import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function courseDifficultyWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRefinementList,
    showCounters: showCounters,
    facetCounterAttribute: "course_difficulty"
  }).widget({
    container: 'course_difficulty',
    attribute: 'course_difficulty',
    operator: "or",
    templates: { item: loadTemplate(showCounters ? "cle_course_difficulty_filter_template_with_counters" : "cle_course_difficulty_filter_template") },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["name:asc"]
  })
}

export function courseDifficultyMobileWidget() {
  return new SelectRefinementWidget({ selectType: "multiple" }).widget({
    attribute: "course_difficulty",
      container: "course_difficulty_mobile",
    sortBy: ["name:asc"]
  })
}
